module.exports = {
	ICONS_PATH: "assets/icons/",
	PROJECTS_URL: "https://s-ferrara.fr/creations/",
	API_URL: "",
};
